import { create } from "zustand";
import { getStorage } from "src/settings/zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IPanel, IPanelConsole, PanelData } from "./interface";

export interface IPanelStore {
    width: number
    panelDatas: PanelData[]
    panels: IPanel[]
    consoles: IPanelConsole[]
    float: IPanel[]
    isHidePanels: boolean
} 

export const usePanelStore: any = create(  
    devtools( persist<IPanelStore>( (set: any, get: any ) => ({
        width: 250, 
        panelDatas: [],
        panels: [],
        consoles: [],
        float: [],
        isHidePanels: false
    }),
    {
        name: 'pe-panel-storage', 
        storage: createJSONStorage( getStorage ), 
    }) )
)